import React from 'react'

import { AtsLockContext } from 'components/common/AtsLock'

import { useImportCandidatesModal } from 'components/modals/ImportCandidatesModal/hooks'
import {
  useCandidateActions,
  useCandidateGroupActions,
  useCandidateState,
  useJobDetailsTab,
  useFilter,
} from './../hooks'

export const useJobOverviewTab = state => {
  const { projectId } = state

  const { isAtsLocked } = React.useContext(AtsLockContext) ?? {}

  const {
    state: { count, search },
    handlers: { setSearch },
  } = useJobDetailsTab()

  const {
    state: { filter },
    handlers: { setFilter },
  } = useFilter()

  const {
    state: { candidate, selected, hasMoveCandidatesFeature },
    handlers: { setCandidate },
  } = useCandidateState()

  const {
    handleImportCandidatesModalClose,
    handleImportCandidatesModalConfirm,
    handleImportCandidatesModalOpen,
    isImportCandidatesModalOpen,
  } = useImportCandidatesModal({ projectId })

  const {
    state: {
      isCandidateManagementModalOpen,
      isDeleteCandidateModalOpen,
      isMoveCandidateModalOpen,
    },
    handlers: {
      getActions,
      handleFavorite,
      handleCandidateManagementModalClose,
      handleCandidateManagementModalConfirm,
      handleCandidateManagementModalOpen,
      handleDeleteCandidateModalClose,
      handleDeleteCandidateModalConfirm,
      handleMoveCandidateModalClose,
      handleMoveCandidateModalConfirm,
    },
  } = useCandidateActions(
    { candidate, projectId, hasMoveCandidatesFeature, isAtsLocked },
    { handleSetCandidate: setCandidate },
  )

  const {
    state: {
      actions,
      isDeleteCandidateGroupModalOpen,
      isExportCandidateGroupModalOpen,
      isMoveCandidateGroupModalOpen,
    },
    handlers: {
      handleDeleteCandidateGroupModalClose,
      handleDeleteCandidateGroupModalConfirm,
      handleExportCandidateGroupModalClose,
      handleMoveCandidateGroupModalClose,
      handleMoveCandidateGroupModalConfirm,
    },
  } = useCandidateGroupActions({
    projectId,
    selected,
    hasMoveCandidatesFeature,
    isAtsLocked,
  })

  return {
    state: {
      actions,
      candidate,
      count,
      search,
      filter,
      hasMoveCandidatesFeature,
      isAtsLocked,
      isCandidateManagementModalOpen,
      isDeleteCandidateModalOpen,
      isImportCandidatesModalOpen,
      isMoveCandidateModalOpen,
      isDeleteCandidateGroupModalOpen,
      isExportCandidateGroupModalOpen,
      isMoveCandidateGroupModalOpen,
    },
    handlers: {
      getActions,
      handleFavorite,
      handleCandidateManagementModalClose,
      handleCandidateManagementModalConfirm,
      handleCandidateManagementModalOpen,
      handleDeleteCandidateModalClose,
      handleDeleteCandidateModalConfirm,
      handleMoveCandidateModalClose,
      handleMoveCandidateModalConfirm,
      handleImportCandidatesModalClose,
      handleImportCandidatesModalConfirm,
      handleImportCandidatesModalOpen,
      handleDeleteCandidateGroupModalClose,
      handleDeleteCandidateGroupModalConfirm,
      handleExportCandidateGroupModalClose,
      handleMoveCandidateGroupModalClose,
      handleMoveCandidateGroupModalConfirm,
      setFilter,
      setSearch,
    },
  }
}
